export default __webpack_public_path__ + "static/media/txt_entrance_05.5f855cb3.svg";